// 导入axios
import axios from 'axios';
import AES from "./AES";
import {
  Message,
  MessageBox
} from 'element-ui';
//1. 创建新的axios实例，
const service = axios.create({
  baseURL: '/api',
  timeout: 10 * 1000 // 超时时间
})
// 2.请求拦截器

service.interceptors.request.use(config => {
  const token = localStorage.getItem("token")
  config.data = JSON.stringify(config.data);
  config.headers = {
    'Content-Type': 'application/json', //配置请求头
    'token': token
  }



  return config
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {



  //接收到响应数据并成功的共有的处理
  if (response.headers.token) {
    localStorage.setItem("token", response.headers.token);
  }
  if (response.data.code === 401) {
    Message.error('身份已过期请重新登录。')
  }
  if (response.data.code === 10028) {
    Message.error('角色不符合，无法查看，请选择对应机构登陆。')
    localStorage.setItem("token",response.headers.token);
    window.location.href="/";
  }

  if (response.data.code === 10007) {
    Message.error('权限不足，无法操作，请选择对应机构登陆。')
    localStorage.setItem("token",response.headers.token);
    window.location.href="/";
  }

  if (response.data.code === 10022) {
    let language = window.localStorage.getItem("language");
    // let router_path = this.$route.path
    // console.log('router_path1')
    // Message.error('token已过期，请重新登陆。')
    // var yemian = window.location.href
    // console.log('yemian')
    // this.$route.params
    // Message.error('router_path1')
    // 输出当前页面的路由，如：/home
    // if(router_path=="login")
    // {
    // }
    var url;
    url = window.location.href; /* 获取完整URL */
    console.log(url)
    // alert(url); //获取当前页面，弹窗提示
    // Message.error(url)
    // http://8.214.57.208:8180/#/login
    //本地测试
    //   if(url!=='http://localhost:8080/#/' &&  url!=='http://localhost:8080/#/login' &&  url!=='http://localhost:8080/#/register' && url!=='http://localhost:8080/#/AllPagesName')
      if(
        //服务器地址
        url!=='http://8.214.57.208:8180/#/' &&  url!=='http://8.214.57.208:8180/#/login' &&  url!=='http://8.214.57.208:8180/#/register' && url!=='http://8.214.57.208:8180/#/AllPagesName'
        //本地地址
        && url!=='http://localhost:8080/#/' &&  url!=='http://localhost:8080/#/login' &&  url!=='http://localhost:8080/#/register' && url!=='http://localhost:8080/#/AllPagesName'
      )
      {
        console.log(language)
      Message.error(language==='JP'?'ユーザーが終了しました。再ログインしてください':'token已过期，请重新登陆。')
    }
    localStorage.setItem("token",response.headers.token);
  }

  if(response.data.code === 10005){
    Message.error('审核失败');
    console.log(response);
    var userInfo = localStorage.getItem("userInfo")
    const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
    console.log(aesFecInfo);
    var roleName=aesFecInfo.roleName;
    if(roleName === "educationalinstitutionuser"){
      //教育机构用户
      window.location.href="#/educationAuditFailure";


    }else if(roleName === "educationalinstitutionadmin"){
      //教育机构管理员
      window.location.href="#/educationAuditFailure";

    }else if(roleName === "medicalinstitutionadmin"){
      //医疗机构管理员
      window.location.href="#/auditFailure";

    }else{
      //医疗机构用户
      window.location.href="#/auditFailure";
    }
  }
  if(response.data.code === 10004){
    Message.error('正在审核中');
    var userInfo = localStorage.getItem("userInfo")
    const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
    console.log(aesFecInfo);
    var id=aesFecInfo.educationId;
    if(id == null || id === ''||id.length==0){
      window.location.href="#/underReview";
    }else{
      window.location.href="#/educationUnderReview";
    }
  }
  if(response.data.code === 10030){
    Message.error('正在审核中');
    var userInfo = localStorage.getItem("userInfo")
    const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
    console.log(aesFecInfo);
    if(roleName === "medicalinstitutionuser" ){
      window.location.href="#/educationalCertificationAdd";
    }else{
      window.location.href = "#/userApplying";
    }
  }
  if(response.data.code === 10001){
    Message.error('审核未通过');
    var userInfo = localStorage.getItem("userInfo")
    const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
    console.log(aesFecInfo);
    if(roleName === "medicalinstitutionuser" ){
      window.location.href="#/userFailure";
    }

  }
  if(response.data.code === 10002){
    Message.error('未绑定用户');
    var userInfo = localStorage.getItem("userInfo");
    const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
    console.log(aesFecInfo);
    var roleName=aesFecInfo.roleName;
    if(roleName === "educationalinstitutionuser" || roleName === "educationalinstitutionadmin"){
      window.location.href="#/educationalCertificationAdd";
    }else{
      window.location.href="#/advancedCertification";
    }
  }
  return response
}, error => {
  //异常响应
  if (error && error.response) {

    switch (error.response.status) {
      case 400:
        error.message =  window.localStorage.getItem("language")==='JP'?'ユーザーが終了しました。再ログインしてください':'错误请求'

        break;
      case 401:
       // error.message = '未授权，请重新登录'
        break;
      case 403:
       // error.message = '拒绝访问'
        break;
      case 404:
       // error.message = '请求错误,未找到该资源'
        break;
      case 405:
      //  error.message = '请求方法未允许'
        break;
      case 408:
      //  error.message = '请求超时'
        break;
      case 500:
        //error.message =  window.localStorage.getItem("language")==='JP'?'要求に失敗しました，再試行するか': '服务器端出错'


        break;
      case 501:
       // error.message = '网络未实现'
        break;
      case 502:
        //error.message = '网络错误'
        break;
      case 503:
       // error.message = '服务不可用'
        break;
      case 504:
       // error.message = '网络超时'
        break;
      case 505:
        error.message = 'http版本不支持该请求'
        break;
      default:
        error.message = `连接错误${error.response.status}`
    }
  } else {
    // 超时处理
    if (JSON.stringify(error).includes('timeout')) {
      Message.error('服务器响应超时，请刷新当前页')
    }
    error.message = '连接服务器失败'
  }

  Message.error(error.message)
  /***** 处理结束 *****/
  //如果不需要错误处理，以上的处理过程都可省略
  return Promise.resolve(error.response)
})
//4.导入文件
export default service


//注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
//  const token = getCookie('名称');//这里取token之前，你肯定需要先拿到token,存一下
//  if(token){
//     // config.params = {'token':token} //如果要求携带在参数中
//     // //如果要求携带在请求头中
//   }



// WEBPACK FOOTER //
// ./src/js/axios.js